import React, {useMemo} from 'react';
import {Card, Circle, FlexColumnSection, FlexRowSection, GreyText} from "../../../styles/globalStyles";
import {t} from 'i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';
import {Colors} from '@arboxappv4/shared/src/styles/Colors';
import {useSelector} from "react-redux";
import {APPOINTMENT_WAITLIST_SETTINGS} from "../../../../../src/constants";
import {projectTypeMainSlice} from "@arboxappv4/shared/src/helpers/constants";

const HowItWorks = (props) => {
    const { } = props;
    const project_type = useSelector(state => state.project?.project_type)
    const box = useSelector(state => state[projectTypeMainSlice[project_type]]?.box)
    const waitlistSetting = useMemo(() => box?.boxes_settings?.find(s => s.prop_name === APPOINTMENT_WAITLIST_SETTINGS)?.properties, [box]);

    const howItWorksItem = (icon, text, color) => (
        <FlexRowSection flex={'unset'} gap={'10px'} align={'start'}>
            <Circle style={{width: 24, height: 24, background: Colors.siteBg, flexShrink: 0}}>
                <FontAwesomeIcon icon={icon} color={color ?? Colors.siteBlack} size={'md'}/>
            </Circle>
            <GreyText color={Colors.grey}>{text}</GreyText>
        </FlexRowSection>
    );

    return (
        <Card flex={'unset'} padding={'17px 21px'} gap={'14px'}>
            <GreyText style={{fontWeight: 600, textTransform: 'uppercase', fontSize: 13}}>{t('appointment-waitlist-how-it-works')}</GreyText>
            {howItWorksItem(regular('bell'), t('appointment-waitlist-how-notify'))}
            {howItWorksItem(regular('bolt'), t('appointment-waitlist-how-time', {time: waitlistSetting ? `${waitlistSetting.confirm_time} ${t(waitlistSetting.confirm_unit)}` : ''}), Colors.purpleIcon)}
            {howItWorksItem(regular('credit-card'), t('appointment-waitlist-how-payment'), Colors.badgeGreenText)}
        </Card>
    );
};

export default HowItWorks;
